import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter, HostBinding,
  HostListener,
  Inject,
  Input,
  Output
} from "@angular/core";
import {KEYBOARD_KEY_PRESSED} from "../../../providers/keyboardEvents.provider";
import {Observable} from "rxjs";
import {DestroyStreamService, IntClickOutsideService} from "../../../services";
import {takeUntil} from "rxjs/operators";
import {DROPDOWN_ANIMATION_E_TO_TOP_L_TO_BOTTOM} from "../../../animations";


@Component({
  selector: 'int-dropdown-area',
  templateUrl: './int-dropdown-area.component.html',
  styleUrls: ['./int-dropdown-area.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    DestroyStreamService,
    IntClickOutsideService
  ],
  animations: [
    DROPDOWN_ANIMATION_E_TO_TOP_L_TO_BOTTOM({duration: 0.2, timingFunction: 'ease'})
  ]
})
export class IntDropdownAreaComponent {

  @Input() excludeElementsForClickOutside: Array<HTMLElement> | HTMLElement | null = null;
  @Input() closeAfterContextClick: boolean = true;
  @Output() clickOutside = new EventEmitter();
  @Output() closeEvent = new EventEmitter();

  constructor(
    private readonly destroy$: DestroyStreamService,
    @Inject(KEYBOARD_KEY_PRESSED) private readonly keyPressed$: Observable<string>,
    private readonly elementRef: ElementRef,
    private readonly clickOutSideService: IntClickOutsideService
  ) {

    this.keyPressed$
      .pipe(takeUntil(this.destroy$))
      .subscribe((key: string) => {
        if(key === 'Escape') {
          this.closeEvent.emit();
        }
      });
  }

  @HostListener('document:click', ['$event'])
  clickOutsideHandler(event: Event) {
    this.outsideProcessing(event);
  }

  @HostListener('document:contextmenu', ['$event'])
  contextClickOutside(event: Event) {
    if(!this.closeAfterContextClick) {
      return;
    }
   this.outsideProcessing(event);
  }

  @HostBinding('@dropdownETTLTB') get animation() {
    return true
  }

  outsideProcessing(event: Event) {
    //@ts-ignore
    if(this.clickOutSideService.isNotExcludeElements(event.target, this.excludeElementsForClickOutside)) {
      this.clickOutside.emit();
    }
  }

  noop(event: Event) {
    event.stopPropagation();
  }
}
